// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__agwY8","milestoneBackground":"milestone_milestoneBackground__6bfTG"};